import { createRouter } from "@tanstack/react-router"
import { ErrorFallback } from "~/components/error"
import { routeTree } from "./routeTree.gen"

declare global {
  interface Window {
    ym?: (id: number, event: string, ...args: unknown[]) => void
  }
}

const YM_ID = 108769016

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    scrollRestoration: true,
    defaultErrorComponent: ErrorFallback,
  })
  if (import.meta.env.PROD && typeof window !== "undefined") {
    router.subscribe("onResolved", ({ toLocation }) => {
      window.ym?.(YM_ID, "hit", toLocation.href, { referer: document.referrer })
    })
  }
  return router
}
